module.exports = require("blessed");


//////////////////
// WEBPACK FOOTER
// external "blessed"
// module id = 58
// module chunks = 0